import { Typography } from "@mui/material";
import { COLORS } from "../../ui/Theme";
import useResponsive from "../../components/hooks/useResponsive";

const TicketClosedMessage = () => {
  const { isMd } = useResponsive();
  return (
    <Typography
      sx={{
        textAlign: "center",
        color: COLORS.RED,
        bgcolor: COLORS.SOFTRED,
        p: "12px",
        borderRadius: "12px",
        fontSize: isMd ? "14px" : "10px",
      }}
    >
      این تیکت توسط ادمین بسته شده است جهت ارسال پیام تیکت جدید ارسال نمایید.
    </Typography>
  );
};

export default TicketClosedMessage;
